import { FaMapMarkerAlt, FaRoute } from 'react-icons/fa';

/** Badge lokasi — dipakai foto & preview kamera */
const LocationBadge = ({ name, distance, coords = null, gpsDebug = null, top = 8 }) => {
    if (!name && !distance && !coords) return null;

    const hasCoords = coords?.latitude != null && coords?.longitude != null;
    const coordText = hasCoords
        ? `${Number(coords.latitude).toFixed(6)}, ${Number(coords.longitude).toFixed(6)}`
        : null;

    // Di bawah tab Masuk/Pulang: desktop butuh ruang lebih besar
    const belowTabs = top === '4.25rem';

    return (
        <div
            className={belowTabs ? 'top-[4.25rem] md:top-[5.25rem]' : undefined}
            style={{
                position: 'absolute',
                ...(belowTabs ? {} : { top }),
                left: 0,
                right: 0,
                zIndex: 50,
                display: 'flex',
                justifyContent: 'center',
                pointerEvents: 'none',
                paddingLeft: 8,
                paddingRight: 8,
            }}
        >
            <div
                className="flex text-white/60 flex-wrap items-center justify-center gap-2 bg-black/20"
                style={{
                    maxWidth: '92%',
                    padding: '6px 10px',
                    borderRadius: 6,
                    fontSize: 13,
                }}
            >
                {name && (
                    <div className='flex items-center gap-2'>
                        <FaMapMarkerAlt className='text-red-500/50' style={{ flexShrink: 0 }} />
                        <span style={{ fontWeight: 600, lineHeight: 1.2 }}>{name}</span>
                    </div>
                )}
                {distance && (
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 11, opacity: 0.95 }}>
                        <FaRoute style={{ flexShrink: 0 }} />
                        {distance}
                    </span>
                )}
                {coordText && (
                    <span style={{ fontFamily: 'ui-monospace, monospace', fontSize: 10, opacity: 0.95 }}>
                        {coordText}
                    </span>
                )}
                {gpsDebug?.tick > 0 && (
                    <span style={{ fontSize: 10, opacity: 0.8 }}>
                        #{gpsDebug.tick}
                        {gpsDebug.accuracy != null ? ` ±${gpsDebug.accuracy}m` : ''}
                    </span>
                )}
            </div>
        </div>
    );
};

export default LocationBadge;
